import $ajax, {$harbor, $dateAcq, $dataPic} from './ajax'

export const _get = (url: string, data: object) => {
    return $harbor.get(url, {
        params: data
    })
}

export const _post = (url: string, data: object, config: any = {} ): Promise<any> => {
    return $harbor.post(url, JSON.stringify(data), config)
}

export const _acqPost = (url: string, data: object) => {
    return $dateAcq.post(url, JSON.stringify(data))
}

export const _picPost = (url: string, data: object) => {
    return $dataPic.post(url, JSON.stringify(data))
}